const roles = [
    { value: 'admin', label: { en: 'Admin', es: 'Administrador' } },
    { value: 'owner', label: { en: 'Owner', es: 'Propietario' } },
];

export default roles;